const currentPageState = {
    MENU_TYPES_PAGE: 'menu_type_page',
    DEFINITION_PAGE: 'definition_page',
    CONFIGURATION_PAGE: 'configuration_page'
};

const menuTypesPage = {
    header: 'Menu Types',
    listPageInContextHelp: 'navigationStudio.menuTypeList.header',
    styles: {
        display: 'initial'
    },
    breadcrumb: 'Menu Types',
    breadcrumbLink: null
};

const definitionPage = {
    header: 'Menu Definition',
    listPageInContextHelp: 'navigationStudio.definitionList.header',
    styles: {
        display: 'none'
    },
    breadcrumb: 'Menu Definition',
    breadcrumbLink: 'definition',
    menuPageInContextHelp: 'navigationStudio.menuDefinition.header',
    submenuPageInContextHelp: 'navigationStudio.submenuDefinition.header',
    itemPageInContextHelp: 'navigationStudio.itemDefinition.header'
};

const configurationPage = {
    header: 'Menu Configuration',
    listPageInContextHelp: 'navigationStudio.configurationList.header',
    breadcrumb: 'Menu Configuration',
    breadcrumbLink: 'configuration',
    menuPageInContextHelp: 'navigationStudio.menuConfiguration.header',
    submenuPageInContextHelp: 'navigationStudio.submenuConfiguration.header',
    itemPageInContextHelp: 'navigationStudio.itemConfiguration.header'
};

export {
    currentPageState,
    menuTypesPage,
    definitionPage,
    configurationPage
};